import React from "react";
import CredenciaisDeAcesso from "../../components/PortalHome/Modal/Tarefas/SituacaoTarefa/PendentesEmitir/CredenciaisDeAcesso";
import { useParams } from "react-router-dom";

function DetalheCredenciaisDeAcesso() {
    const { id } = useParams();
    //console.log("useParams id:", id); // deve imprimir "1012"

  return (
    <>
      <div className="centralizar">
        <CredenciaisDeAcesso clienteId={id}/>
      </div>
    </>
  );
}
export default DetalheCredenciaisDeAcesso;
